import { 
    HashRouter as Router,
    Route,
    Routes
} from 'react-router-dom';
import Signup from './Components/Signup';
import Login from './Components/Login';
import ChangePass from './Components/ChangePass'

const isDark = true;
const componentColor = isDark?"#171f2e":"#dbe4ff";
const TextColor = isDark?"white":"black";

document.body.style.backgroundColor = isDark?"#111827":"white";
document.body.style.color = isDark?"white":"black";

function getCSRF(){
    var x = document.querySelector("input");
    if(x !== null) return x.value;
    else return null;
}

export default function App(){
    return(
        <Router basename="/">
            <Routes>
                <Route exact path='/signup' element={<Signup color={componentColor} textColor={TextColor} csrf={getCSRF()}/>}/>
                <Route exact path='/login' element={<Login color={componentColor} textColor={TextColor} csrf={getCSRF()}/>}/>
                <Route exact path='/changePass' element={<ChangePass color={componentColor} textColor={TextColor} csrf={getCSRF()}/>}/>
            </Routes>
        </Router>
    )
}